import type { TranslationDict } from '../en';

const te: TranslationDict = {
  // ─── Header ───
  'header.buy': 'కొనుగోలు',
  'header.sell': 'అమ్మకం',

  // ─── SpendCard ───
  'spend.label': 'మీరు ఖర్చు చేస్తున్నారు',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'మీరు పొందుతున్నారు',

  // ─── PaymentCard ───
  'payment.label': 'చెల్లింపు పద్ధతి',
  'payment.select': 'ఎంచుకోండి',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'ఈ జంటకు చెల్లింపు పద్ధతులు అందుబాటులో లేవు',

  // ─── WalletCard ───
  'wallet.label': 'స్వీకరించే వాలెట్ చిరునామా',
  'wallet.placeholderBuy': 'మీ స్వీకరించే చిరునామాను నమోదు చేయండి',
  'wallet.placeholderSell': 'మీ పంపే చిరునామాను నమోదు చేయండి',
  'wallet.validating': 'చిరునామా ధృవీకరించబడుతోంది...',
  'wallet.invalid': 'చెల్లుబాటయ్యే వాలెట్ చిరునామాను నమోదు చేయండి',
  'wallet.invalidServer': 'చెల్లని వాలెట్ చిరునామా',

  // ─── CtaButton ───
  'cta.buy': '{crypto} కొనుగోలు చేయండి',
  'cta.sell': '{crypto} అమ్మండి',
  'cta.gettingPrice': 'అత్యుత్తమ ధర వెతుకుతోంది...',
  'cta.processing': 'ప్రాసెస్ అవుతోంది...',

  // ─── Footer ───
  'footer.poweredBy': 'ద్వారా నడపబడుతోంది ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'రేటు వివరాలు',
  'rate.close': 'మూసివేయి',
  'rate.updatesIn': 'రేటు 00:{seconds} లో నవీకరించబడుతుంది',
  'rate.noQuote': 'కోటేషన్ అందుబాటులో లేదు',
  'rate.exchangeRate': 'మారకపు రేటు',
  'rate.processingFee': 'ప్రాసెసింగ్ రుసుము',
  'rate.networkFee': 'నెట్‌వర్క్ రుసుము',
  'rate.provider': 'సేవా సంస్థ',

  // ─── Toast ───
  'toast.orderCreated': 'ఆర్డర్ సృష్టించబడింది',
  'toast.redirecting': 'చెక్అవుట్‌కు మళ్లిస్తోంది...',
  'toast.orderFailed': 'ఆర్డర్ విఫలమైంది',
  'toast.couldNotCreate': 'ఆర్డర్ సృష్టించలేకపోయాం',
  'toast.quoteError': 'కోటేషన్ లోపం',
  'toast.noProviders': 'సేవా సంస్థలు లేవు',
  'toast.somethingWrong': 'ఏదో తప్పు జరిగింది',

  // ─── Form errors ───
  'error.amountZero': 'మొత్తం 0 కంటే ఎక్కువగా ఉండాలి',
  'error.minAmountFiat': 'కనీస మొత్తం {min} {currency}',
  'error.minAmountCrypto': 'కనీస మొత్తం {min} {currency}',
  'error.noProviders': 'ఈ కలయికకు సేవా సంస్థలు అందుబాటులో లేవు',
  'error.currencyUnavailableBuy': 'ఈ కరెన్సీ కొనుగోలు ఆర్డర్లకు అందుబాటులో లేదు',
  'error.currencyUnavailableSell': 'ఈ కరెన్సీ అమ్మకపు ఆర్డర్లకు అందుబాటులో లేదు',

  // ─── Parity banner ───
  'parity.info': 'మీకు {receiveAmount} {crypto} కోసం చార్జ్ చేయబడుతుంది, మిగిలిన {spendAmount} {fiat} వరకు మీ {partner} ఖాతాలో జమ అవుతుంది',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'సురక్షిత చెల్లింపు',
  'redirect.title': 'చెల్లింపు కొనసాగించండి',
  'redirect.description': 'మీ చెల్లింపు పూర్తి చేయడానికి మిమ్మల్ని {gateway}కి మళ్లిస్తాం.',
  'redirect.countdown': '{seconds} సెకన్లలో మళ్లిస్తోంది...',
  'redirect.openTab': 'కొత్త ట్యాబ్‌లో ACH తెరవండి',
  'redirect.cancel': 'రద్దు చేయి',

  // ─── Checkout Step ───
  'checkout.noOrder': 'ఆర్డర్ కనుగొనబడలేదు',
  'checkout.goBack': 'వెనక్కి వెళ్ళు',
  'checkout.expired': 'చెక్అవుట్ గడువు ముగిసింది',
  'checkout.expiredDesc': 'సెషన్ గడువు ముగిసింది. దయచేసి మళ్లీ ప్రయత్నించండి.',
  'checkout.startOver': 'మళ్లీ మొదలుపెట్టు',
  'checkout.cancel': 'రద్దు చేయి',
  'checkout.loading': 'చెక్అవుట్ లోడ్ అవుతోంది...',
  'checkout.iframeTitle': 'సేవా సంస్థ చెక్అవుట్',
  'checkout.widgetTitle': 'చెల్లింపు చెక్అవుట్',
  'checkout.unknownMethod': 'తెలియని చెక్అవుట్ పద్ధతి',

  // ─── Processing Step ───
  'processing.default': 'మీ ఆర్డర్ ప్రాసెస్ అవుతోంది...',
  'processing.pending': 'చెల్లింపు నిర్ధారణ కోసం వేచి ఉంది...',
  'processing.active': 'మీ లావాదేవీ ప్రాసెస్ అవుతోంది...',
  'processing.generic': 'ప్రాసెస్ అవుతోంది...',
  'processing.checkingStatus': 'స్థితి తనిఖీ చేయబడుతోంది...',
  'processing.orderId': 'ఆర్డర్ ఐడి',
  'processing.provider': 'సేవా సంస్థ',
  'processing.amount': 'మొత్తం',
  'processing.receiving': 'స్వీకరించబడుతోంది',
  'processing.network': 'నెట్‌వర్క్',
  'processing.toAddress': 'స్వీకరించే చిరునామా',
  'processing.usuallyMinutes': 'ఇది సాధారణంగా కొన్ని నిమిషాలు పడుతుంది.',
  'processing.safeToClose': 'మీరు ఈ పేజీని సురక్షితంగా మూసివేయవచ్చు — పూర్తయిన తర్వాత మేము ఇమెయిల్ పంపుతాం.',

  // ─── Complete Step ───
  'complete.buyTitle': 'కొనుగోలు పూర్తయింది!',
  'complete.sellTitle': 'అమ్మకం పూర్తయింది!',
  'complete.buyDesc': 'మీ {crypto} మీ వాలెట్‌కు పంపబడింది.',
  'complete.sellDesc': 'మీ {fiat} చెల్లింపు ప్రాసెస్ అవుతోంది.',
  'complete.amountBuy': 'స్వీకరించిన మొత్తం',
  'complete.amountSell': 'అమ్మిన మొత్తం',
  'complete.paidBuy': 'చెల్లించిన మొత్తం',
  'complete.paidSell': 'చెల్లింపు మొత్తం',
  'complete.network': 'నెట్‌వర్క్',
  'complete.wallet': 'వాలెట్',
  'complete.transaction': 'లావాదేవీ',
  'complete.provider': 'సేవా సంస్థ',
  'complete.orderId': 'ఆర్డర్ ఐడి',
  'complete.completed': 'పూర్తయింది',
  'complete.viewExplorer': 'ఎక్స్‌ప్లోరర్‌లో చూడండి',
  'complete.done': 'సరే',

  // ─── Error Step ───
  'errorStep.failed': 'చెల్లింపు విఫలమైంది',
  'errorStep.cancelled': 'ఆర్డర్ రద్దయింది',
  'errorStep.expired': 'ఆర్డర్ గడువు ముగిసింది',
  'errorStep.refunded': 'ఆర్డర్ తిరిగి చెల్లించబడింది',
  'errorStep.unknown': 'ఏదో తప్పు జరిగింది',
  'errorStep.failedBuy': 'మీ చెల్లింపు ప్రాసెస్ చేయలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి లేదా వేరే చెల్లింపు పద్ధతిని ఉపయోగించండి.',
  'errorStep.failedSell': 'మీ అమ్మకం ప్రాసెస్ చేయలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి.',
  'errorStep.cancelledBuy': 'మీ ఆర్డర్ రద్దు చేయబడింది. ఏ చెల్లింపూ ప్రాసెస్ కాలేదు.',
  'errorStep.cancelledSell': 'మీ అమ్మకం రద్దు చేయబడింది. ఏ క్రిప్టోకూ బదిలీ జరగలేదు.',
  'errorStep.expiredBuy': 'మీ ఆర్డర్ గడువు ముగిసింది. కొత్త కొనుగోలు ప్రారంభించండి.',
  'errorStep.expiredSell': 'మీ ఆర్డర్ గడువు ముగిసింది. కొత్త అమ్మకం ప్రారంభించండి.',
  'errorStep.refundedBuy': 'మీ చెల్లింపు తిరిగి ఇవ్వబడింది. 5-10 వ్యాపార దినాలలో మొత్తం మీ ఖాతాలో కనిపిస్తుంది.',
  'errorStep.refundedSell': 'మీ క్రిప్టో తిరిగి ఇవ్వబడింది. త్వరలో మొత్తం మీ వాలెట్‌లో కనిపిస్తుంది.',
  'errorStep.genericDesc': 'అనుకోని లోపం సంభవించింది. దయచేసి మళ్లీ ప్రయత్నించండి.',
  'errorStep.orderId': 'ఆర్డర్ ఐడి',
  'errorStep.tryAgain': 'మళ్లీ ప్రయత్నించు',
  'errorStep.startOver': 'మళ్లీ మొదలుపెట్టు',
  'errorStep.return': 'తిరిగి వెళ్ళు',
  'errorStep.needHelp': 'సహాయం కావాలా? సంప్రదించండి ',
  'errorStep.reference': 'సూచన: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'కొనుగోలు నిర్ధారించండి',
  'confirm.sellTitle': 'అమ్మకం నిర్ధారించండి',
  'confirm.loading': 'లోడ్ అవుతోంది...',
  'confirm.provider': 'సేవా సంస్థ',
  'confirm.youPay': 'మీరు చెల్లిస్తున్నారు',
  'confirm.youSell': 'మీరు అమ్ముతున్నారు',
  'confirm.youReceive': 'మీరు పొందుతున్నారు',
  'confirm.wallet': 'వాలెట్',
  'confirm.network': 'నెట్‌వర్క్',
  'confirm.refundAddress': 'రిఫండ్ చిరునామా',
  'confirm.parityNote': 'సేవా సంస్థ నుండి వసూలు చేసిన మొత్తం భిన్నంగా ఉండవచ్చు. మిగిలిన {amount} {crypto} వరకు మీ {partner} ఖాతాలో జమ అవుతుంది.',
  'confirm.processing': 'ప్రాసెస్ అవుతోంది...',
  'confirm.confirmPay': 'నిర్ధారించి చెల్లించండి',
  'confirm.confirmSell': 'నిర్ధారించి అమ్మండి',
  'confirm.payout': '{currency} చెల్లింపు',

  // ─── Modals ───
  'modal.selectFiat': 'ఫియట్ కరెన్సీ ఎంచుకోండి',
  'modal.selectCrypto': 'క్రిప్టో కరెన్సీ ఎంచుకోండి',
  'modal.choosePayment': 'చెల్లింపు పద్ధతి ఎంచుకోండి',
  'modal.selectCountry': 'మీ దేశాన్ని ఎంచుకోండి',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'ప్రసిద్ధమైనవి',
  'modal.recommended': 'సిఫార్సు చేయబడినవి',
  'modal.noCurrencies': 'కరెన్సీలు కనుగొనబడలేదు',
  'modal.noPaymentMethods': 'చెల్లింపు పద్ధతులు కనుగొనబడలేదు',
  'modal.noCountries': 'దేశాలు కనుగొనబడలేదు',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'స్థానం',
  'settings.darkMode': 'డార్క్ మోడ్',
  'settings.privacy': 'గోప్యతా విధానం',
  'settings.terms': 'వినియోగ నిబంధనలు',
  'settings.language': 'భాష',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp ఎంచుకోండి',
  'modal.bestPrice': 'అత్యుత్తమ ధర',
  'modal.noQuotes': 'ఈ అభ్యర్థనకు కోటేషన్లు అందుబాటులో లేవు',
  'modal.noProvidersFound': 'సేవా సంస్థలు కనుగొనబడలేదు',
  'payment.unavailableFor': '{currency} కోసం చెల్లింపు పద్ధతులు అందుబాటులో లేవు',
  'skeleton.poweredBy': 'NowRamp ద్వారా నడపబడుతోంది',
  'error.createOrderFailed': 'ఆర్డర్ సృష్టించడం విఫలమైంది',
  'errorStep.returnToMerchant': 'వ్యాపారికి తిరిగి వెళ్ళు',
  'confirm.cryptoOnNetwork': '{crypto} {network}లో',
  'payment.name.card': 'కార్డ్',
  'payment.name.bankTransfer': 'బ్యాంక్ బదిలీ',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default te;
